import React, { useEffect, useState } from "react";
import Basic from "./Main/Basic/Basic";
import InvoicePreview from "./Main/InvoicePreview";
import Side from "./Side/Side";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import useWallet from "../../../utils/hooks/useWalletConnect";
import { fetchProfile } from "../../../redux/profile/action";
import { updateUser } from "../../../redux/profile/api";
import useSignature from "../../../utils/hooks/useSignature";

export default function Profile() {
  const { account, isConnected } = useWallet();
  const { isSignIn,getAuth } = useSignature();
  const { signature, nonce } = useSelector(({ user }) => user);
  const {
    profile: { data, loading, error },
  } = useSelector(({ profile }) => profile);
  const dispatch = useDispatch();

  const [tab, setTab] = useState("basic");
  const [isLoading, setIsLoading] = useState(loading);

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    fetchProfileData();
  }, [account, signature]);
  const fetchProfileData = () => {
    if (!!account && !!signature) {
      const payload = {
        $auth: getAuth,
      };
      dispatch(fetchProfile(payload));
    }
  };

  return (
    <div className="layout">
      <div className="auto__container">
        {isLoading ? <h3 className="placeholder"> </h3> : <h3>My profile</h3>}
        <div className="layout__inner box">
          {isLoading ? (
            <div className="layoutSide">
              <div className="layoutSide__btn placeholder"></div>
              <div className="layoutSide__btn placeholder"></div>
            </div>
          ) : (
            <Side tab={tab} setTab={setTab} />
          )}
          {isLoading ? (
            <div className="layoutMain placeholder"></div>
          ) : (
            <>
              {tab === "basic" && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2 }}
                  exit={{ opacity: 0, y: 10 }}
                  className="layoutMain"
                >
                  <Basic
                    fetchProfileData={fetchProfileData}
                    data={data}
                    isSignIn={isSignIn}
                    isConnected={isConnected}
                    getAuth={getAuth}
                  />
                </motion.div>
              )}
              {tab === "more" && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.2 }}
                  exit={{ opacity: 0, y: 10 }}
                  className="layoutMain"
                >
                  <InvoicePreview />
                </motion.div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
